import _ from "./underscore.js";
import baseIteratee from "./_baseIteratee.js";
import iteratee from "./iteratee.js";
export default function cb(value, context, argCount) {
  if (_.iteratee !== iteratee) return _.iteratee(value, context);
  return baseIteratee(value, context, argCount);
}
